// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 768 ? "App" : chunkId) + "." + {"130":"0236ef6b","768":"8ee5a918"}[chunkId] + ".chunk.js";
};